<mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header class="section-panel-header">
        <mat-panel-title>
            <app-section-header
                [title]="sectionDescription.title"
                [description]="sectionDescription.description"
            ></app-section-header>
        </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-form-field appearance="outline" class="full-width">
        <mat-label>Privacy Policy URL</mat-label>
        <input matInput id="privacy-policy-url" formControlName="privacyUrl" />
        @if (privacyUrlControl.invalid && privacyUrlControl.hasError('pattern')) {
            <mat-error>
                <app-invalid-field
                    [field]="'privacyUrl'"
                    [messageList]="legalAndTermsErrors['privacyUrl']"
                ></app-invalid-field
            ></mat-error>
        }
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
        <mat-label>Terms of Use URL</mat-label>
        <input matInput id="terms-of-use-url" formControlName="termsUrl" />
        @if (termsUrlControl.invalid && termsUrlControl.hasError('pattern')) {
            <mat-error>
                <app-invalid-field
                    [field]="'termsUrl'"
                    [messageList]="legalAndTermsErrors['termsUrl']"
                ></app-invalid-field
            ></mat-error>
        }
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
        <mat-label> FAQ URL </mat-label>
        <input matInput id="faq-url" formControlName="faqURL" (blur)="validateFaqURL()" />
        @if (faqUrlControl.invalid && faqUrlControl.hasError('pattern')) {
            <mat-error>
                <app-invalid-field [field]="'faqURL'" [messageList]="legalAndTermsErrors['faqURL']"></app-invalid-field>
            </mat-error>
        }
        @if (validatingFaqURL) {
            <mat-hint class="d-flex mt-1">Validating url <mat-spinner diameter="20"></mat-spinner></mat-hint>
        }
    </mat-form-field>
</mat-expansion-panel>
